import React, {useEffect, useState} from 'react';
import {Col} from 'reactstrap';
import SectorInfo from '../../../components/sectorInfo/SectorInfo';
import {useParams} from 'react-router-dom';
import {  getAllPotentialRisks} from '../../../../../services/externalizations/externalizationService';
import {t} from 'react-switch-lang';
import {Tooltip} from 'antd';

const PotentialRisks = () => {
  const { id } = useParams();
  const [data, setData]= useState()

  useEffect(() => {
    getAllPotentialRisks(id).then((res) => {
      setData(res?.data);
    })
  }, [id]);
  return (
    <div style={{display: 'flex',flexWrap: 'wrap', gap: '20px 0px', paddingRight: '30px',marginTop: '30px'}}>
      { data?.map(r =>
        <Col className="col-12">
        <div className="risk-column">
            <p><b><a href={`/potential-risk/${r?.id}`}>
              {r?.title ? r?.title : ''}
            </a></b></p>
        </div>
  </Col>)}
    </div>
  );
};

export default PotentialRisks;